<script setup lang="ts">
const card = inject(keys.packetVariantCard);
</script>

<template>
  <PacketVariantCardAction v-if="card?.secondary" :variant="card.secondary" />
</template>
